import { Component, OnInit } from '@angular/core';
import { AppService } from 'src/app/app.service';
import { ActivatedRoute,Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-visitor-entry',
  templateUrl: './visitor-entry.component.html',
  styleUrls: ['./visitor-entry.component.scss']
})
export class VisitorEntryComponent implements OnInit {


  public add: any = {};
  public btndisable: boolean = false;

  constructor(public appservice:AppService,private toastr: ToastrService, public router: Router, private http: HttpClient) { 
    this.appservice.get_Employee_Details();
    this.appservice.get_Reference();
    this.get_Field_Setting();
    this.get_Barcode();
    this.get_Visiting_Details();
  }

  public Visiting_Details_: any[]= [];
  get_Visiting_Details() {
    this.add.Contact_No = this.appservice.getItem("Phone_Number");
    this.appservice.get("Api/Visitor/get_Visiting_Details_?Contact_No="+this.add.Contact_No).subscribe((res: any) => {
      this.Visiting_Details_ = JSON.parse(res).record;
      this.add.Visitor_Name=this.Visiting_Details_[0].Visitor_Name;
      this.add.Last_Name=this.Visiting_Details_[0].Last_Name;
      this.add.Company_Name=this.Visiting_Details_[0].Company_Name;
      this.add.Gender=this.Visiting_Details_[0].Gender;
      this.add.Purpose=this.Visiting_Details_[0].Purpose;

    });
  }

  get_Field_Setting() {
    this.appservice.getc("Api/Setting/get_Field_Setting").subscribe((res: any) => {
      this.appservice.Field_Setting = JSON.parse(res).record;
      this.appservice.get_fields_of('Visitor_Details').forEach((activity: any) => {
        if (activity.Default_Value == "T_Date") {
          this.add[activity.Field] = this.appservice.T_Date;
        }
        else if (activity.Default_Value == "T_Datetime") {
  
          this.add[activity.Field] = this.appservice.T_Date_Time;
        }
        else {
          this.add[activity.Field] = activity.Default_Value;
        }
  
  
      });
    this.add.Serial_No = "";  
    this.add.Visitior_Status = "Check in";
    this.add.Approval_Status = "Pending";
    this.add.Contact_No = this.appservice.getItem("Phone_Number");
    });
  }

  get_Barcode() {
    this.appservice.getc("Api/Master/get_V_Barcode").subscribe((res: any) => {
      this.add.Barcode = res;

    });
  }



  public Valid: boolean = true;

  addData() {

    this.Valid = true;
    this.appservice.get_fields_of('Visitor_Details').filter(e => String(e.Validate).toLocaleLowerCase() == "true").forEach((data) => {

      if (this.add[data.Field] == "") {
        this.Valid = false;
        return;
      }

    });

    try{
      this.add.V_Person_ID = this.appservice.Employee_Details_Rows.filter(e => e.Contact_No == this.add.V_Person_Contact)[0].ID;
    }
    catch{
      this.add.V_Person_ID="0";
    }

    if (this.add.Visitor_Name === "") {
        this.Valid = false;
        this.toastr.error('Visitor Name is required', "Error", { timeOut: 3000 });
        return;
      }
      if (this.add.Company_Name === "") {
        this.Valid = false;
        this.toastr.error('Company Name is required', "Error", { timeOut: 3000 });
        return;
      }
      if (this.add.Purpose === "") {
        this.Valid = false;
        this.toastr.error('Purpose of Visit is required', "Error", { timeOut: 3000 });
        return;
      }
      if (this.add.V_Person === "") {
          this.Valid = false;
          this.toastr.error('Meeting Person is required', "Error", { timeOut: 3000 });
          return;
        }
        if (this.add.V_Person_Contact === "") {
            this.Valid = false;
            this.toastr.error('Meeting Person Mobile Number is required', "Error", { timeOut: 3000 });
            return;
          }
          if (this.add.V_Person_ID === "0") {
            this.Valid = false;
            this.toastr.error('Please enter a valid Meeting Person Mobile Number', "Error", { timeOut: 3000 });
            return;
          }

          if (this.add.Laptop_Permit === "Yes") {
            if (this.add.Serial_No === "") {
            this.Valid = false;
            this.toastr.error('Please enter a valid Serial No', "Error", { timeOut: 3000 });
            return;
            }
          }

    this.add.Company = this.appservice.Company;
    this.add.Company_ID = this.appservice.Company;
    this.add.Created_by = this.appservice.CREATED_BY;
    this.add.items = this.appservice.Details_Row;
    this.add.Feed_Back_Link = this.appservice.Feed_Back_Link;
    this.add.V_Branch = "1";
       this.add.Visit_ID = "1";
    this.add.Table_Name = "Visitor_Details";
    if (this.Valid) {
      this.btndisable = true;

      this.http.post(this.appservice.Server_URL + 'api/Master/Post_Visitor', this.add, { headers: this.appservice.headers })
        .subscribe(
          (val: string) => {      

            if (val == "True") {
              this.btndisable = false;
              this.appservice.isEdit = false;   
              this.appservice.setItem("Barcode",this.add.Barcode);
              this.appservice.setItem("V_Person_ID",this.add.V_Person_ID);
              this.appservice.Details_Row = [];
              // this.appservice.back();
             return this.router.navigate(['/visitor-selfie']);
            }
            else {
              this.btndisable = false;
              this.toastr.error(val, "Error", { timeOut: 3000 });
            }
          },
          response => {
            this.toastr.error('Error ', response, {
              timeOut: 3000
            });

          });

    }
    else{
      this.toastr.error('Fill All Mandatory Fields', "Error", { timeOut: 3000 });
    }
  }

  get_Ph_No(event: Event): void {
    try {
      const inputElement = event.target as HTMLInputElement;
      const inputValue = inputElement.value;
    
      this.appservice.Selected_Customer = this.appservice.Employee_Details_Rows.filter(e => e.Contact_No == inputValue)[0];
    
      this.add.V_Person_ID = this.appservice.Selected_Customer.ID;
      this.add.V_Person = this.appservice.Selected_Customer.Name;
      this.add.V_Department = this.appservice.Selected_Customer.Department;
      
      }catch{}
  }

  
  ngOnInit(): void {
    this.appservice.Company = "_"+this.appservice.getItem("Company");;
    
    this.appservice.get_Area_Details();
  }

}
